import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CorrectionInvoicesActions} from '../store';
import {CorrectionInvoicesSelectors} from '../store/selectors';

@Injectable()
export class CorrectionInvoicesLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readCorrectionInvoicesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readCorrectionInvoicesDone(): Observable<boolean> {

    return this.store$.pipe(
      select(CorrectionInvoicesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store$.dispatch(CorrectionInvoicesActions.ReadCorrectionInvoices({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
